<template>
	<div class="gallery-detail">
		<!-- 顶部导航 -->
		<div class="nav-bar flex-row-ac-jb">
			<button class="back-button" @click="goList">返回列表</button>
			<button class="next-button" @click="goNext" v-if="!nextArticleId">下一篇</button>
		</div>

		<!-- 内容容器 -->
		<div class="content-container">
			<!-- 文章标题 -->
			<h1 class="article-title">{{ article.articleTitle || '加载中...' }}</h1>

			<!-- 文章内容 -->
			<div class="article-content flex-col-ac-js" v-if="article.articleRichContent"
				v-html="article.articleRichContent"></div>

			<!-- 原文信息 -->
			<div class="original-info" v-if="article.articleTitle">
				<div class="info-header flex-row-ac-js" @click="toggleOriginalInfo">
					<h3>原文信息</h3>
					<img
						:src="originalInfoExpanded ? require('@/assets/arw-close.png') : require('@/assets/arw-open.png')" />
				</div>
				<div v-if="originalInfoExpanded" class="info-content">
					<p><span>原文链接：</span><a :href="article.articleSourceUrl"
							target="_blank">{{ article.articleSourceUrl }}</a>
					</p>
					<p><span>作者：</span>{{ article.articleAuthor }}</p>
				</div>
			</div>

			<!-- 加载中 -->
			<div v-if="loading" class="loading">
				<div class="loading-spinner"></div>
				<p>加载中...</p>
			</div>

			<!-- 加载失败 -->
			<div v-if="error" class="error">
				<p>{{ error }}</p>
				<button @click="fetchArticleDetail">重试</button>
			</div>
		</div>

		<!-- 底部分享栏 -->
		<div class="share-bar flex-row-ac-jb" v-if="article.articleTitle">
			<div class="share-left">
				<!-- 微信按钮暂不做 -->
				<div class="share-button" @click="copyLink">
					<img src="@/assets/copy-link.png" />
				</div>
			</div>
			<div class="share-right">
				<div class="flex-row-ac-js">
					<img class="view-icon" src="@/assets/view.png" />
					<span>{{ article.browseNum }}</span>
				</div>
				<div class="flex-row-ac-je">
					<img :src="article.ifUpvote ? require('@/assets/collect-on.png') : require('@/assets/collect.png')"
						@click="collectArticle(article)" />
					<span>{{ article.upvoteNum }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'

	export default {
		name: 'GalleryDetail',
		data() {
			return {
				article: {},
				loading: false,
				error: '',
				projectInfoExpanded: false,
				originalInfoExpanded: false,
				nextArticleId: '',
				copySuccess: false
			}
		},
		computed: {
			...mapGetters(['userInfo'])
		},
		watch: {
			'$route.query.articleId': {
				handler() {
					this.fetchArticleDetail()
				},
				immediate: true
			}
		},
		methods: {
			fetchArticleDetail() {
				let articleId = this.$route.query.articleId

				if (!articleId) {
					this.error = '文章ID不存在'
					return
				}
				this.loading = true
				this.error = ''
				let params = {
					articleId: articleId
				};
				console.log("------接口请求-参数--api.getArticleById");
				console.log(params);
				this.$http.getArticleById(params).then((res) => {
					console.log("------接口请求-结果--api.getArticleById");
					console.log(res)
					if (res && res.code === 0 && res.data) {
						this.article = res.data
						// 处理富文本中的图片跨域问题
						if (this.article.articleRichContent) {
							this.article.articleRichContent = this.processRichContentImages(this.article
								.articleRichContent)
						}
					} else {
						this.error = '获取文章详情失败'
					}
				}).catch((err) => {
					this.error = '网络错误，请稍后重试'
					console.error('获取文章详情失败:', err)
				}).finally(() => {
					this.loading = false
				});
			},

			// 模拟获取下一篇文章ID
			getNextArticle() {
				// 实际项目中可能需要调用接口或根据当前ID计算
			},

			// 切换项目信息显示状态
			toggleProjectInfo() {
				this.projectInfoExpanded = !this.projectInfoExpanded
			},

			// 切换原文信息显示状态
			toggleOriginalInfo() {
				this.originalInfoExpanded = !this.originalInfoExpanded
			},

			// 处理富文本内容中的图片，添加referrerPolicy属性解决跨域问题
			processRichContentImages(htmlContent) {
				if (!htmlContent) return htmlContent

				// 创建一个临时DOM元素来处理HTML内容
				const tempDiv = document.createElement('div')
				tempDiv.innerHTML = htmlContent

				// 获取所有图片元素
				const imgElements = tempDiv.querySelectorAll('img')

				// 为每个图片添加referrerPolicy属性
				imgElements.forEach(img => {
					img.setAttribute('referrerPolicy', 'no-referrer')
				})

				// 返回处理后的HTML内容
				return tempDiv.innerHTML
			},

			// 返回列表
			goList() {
				// 使用更安全的方式判断是否可以返回上一页
				// window.history.length > 1 表示历史记录中存在其他页面
				// if (window.history.length > 1) {
				// 	this.$router.go(-1);
				// } else {
				// 如果没有历史记录，则跳转到画廊列表
				this.$router.push('/gallery/list')
				// }
			},

			// 下一篇
			goNext() {
				if (this.article.articleNextId) {
					this.$router.push({
						path: '/gallery/detail',
						query: {
							articleId: this.article.articleNextId
						}
					})
				} else {
					this.$message.error('下一篇不存在');
				}
			},

			// 复制链接
			copyLink() {
				const url = window.location.href;
				const textarea = document.createElement('textarea');
				document.body.appendChild(textarea);
				textarea.value = url;
				textarea.select();
				document.execCommand('copy');
				document.body.removeChild(textarea);
				this.$message.success('URL已复制到剪贴板');
			}

		}
	}
</script>

<style scoped lang="scss">
	.gallery-detail {
		width: 100%;
		background-color: #F8F8F8;
		padding: 30px 18vw 100px;

		.nav-bar {
			background: white;
			height: 80px;
			border: 1px solid #CECECE;
			border-radius: 20px;
			margin-bottom: 30px;
			padding: 0 40px;

			.back-button,
			.next-button {
				background-color: white;
				border: none;
				font-weight: 500;
				font-size: 22px;
				color: #0066FF;
				cursor: pointer;
				transition: all 0.3s ease;

				&:hover {
					border-color: #409eff;
					color: #409eff;
				}
			}
		}

		.content-container {
			background: white;
			border-radius: 20px;
			padding: 40px;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

			.article-title {
				font-size: 28px;
				font-weight: 600;
				color: #333;
				margin-bottom: 40px;
				line-height: 1.5;
			}

			.project-info,
			.original-info {
				background-color: #F4FAFF;
				border-radius: 20px;
				padding: 0 30px;

				.info-header {
					height: 80px;
					cursor: pointer;
					user-select: none;

					h3 {
						font-size: 20px;
						font-weight: 500;
						color: #333;
						line-height: 80px;
					}

					img {
						width: 16px;
						height: 9px;
						transition: transform 0.3s ease;
						margin-left: 8px;
					}
				}

				.info-content {
					padding-bottom: 30px;

					p {
						margin-bottom: 10px;
						font-weight: 400;
						font-size: 14px;
						color: #737373;

						span {
							font-weight: 500;
							color: #737373;
						}

						a {
							color: #409eff;
							text-decoration: none;

							&:hover {
								text-decoration: underline;
							}
						}
					}

					p:last-child {
						margin-bottom: 0;
					}
				}
			}

			.article-content {
				margin-bottom: 40px;
				flex: 1;

				p {
					margin-bottom: 20px !important;
					font-size: 16px;
					line-height: 1.8;
					color: #333;

					img {
						width: 100% !important;
						height: auto;
						border-radius: 10px;
						margin: 20px 0;
					}
				}
			}

			.loading,
			.error {
				text-align: center;
				padding: 60px 0;

				.loading-spinner {
					width: 40px;
					height: 40px;
					border: 4px solid #f3f3f3;
					border-top: 4px solid #409eff;
					border-radius: 50%;
					animation: spin 1s linear infinite;
					margin: 0 auto 20px;
				}

				p {
					color: #999;
					font-size: 16px;
				}

				button {
					margin-top: 20px;
					padding: 8px 16px;
					border: 1px solid #409eff;
					background: #409eff;
					color: white;
					border-radius: 4px;
					cursor: pointer;
					transition: all 0.3s ease;

					&:hover {
						background: #66b1ff;
						border-color: #66b1ff;
					}
				}
			}
		}

		.share-bar {
			width: 100%;
			height: 80px;
			background-color: rgba(0, 0, 0, 0.6);
			padding: 20px 40px;
			position: absolute;
			bottom: 0;
			left: 0;
			padding: 0 18vw;

			.share-left {
				.share-button {
					cursor: pointer;

					img {
						width: 26px;
						height: 25px;
					}
				}
			}

			.share-right {
				display: flex;
				align-items: center;
				gap: 20px;

				img {
					width: 23px;
					height: 20px;
					margin-right: 5px;
					cursor: pointer;
				}

				.view-icon {
					width: 31px;
					height: 20px;
					cursor: default;
				}

				span {
					color: #FFF;
					font-size: 16px;
				}
			}
		}
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.gallery-detail {
			padding: 10px;

			.content-container {
				padding: 20px;

				.article-title {
					font-size: 22px;
				}
			}

			.share-bar {
				padding: 15px 20px;
			}
		}
	}
</style>